import { useEffect, useState } from "react";
import { CustomLoading } from "./CustomLoading";
import { Card, Line } from "ktm-ui";
import "../styles/Settings.css";
import EditGeneralSettingModal from "./EditGeneralSettingModal";


const GeneralSettings = ({ policyId }) => {
    const [loading, setLoading] = useState(true);
    const [showEditGeneralModal, setShowEditGeneralModal] = useState(false);
    const [showEditCompanyStatusModal, setShowEditCompanyStatusModal] = useState(false);
    const [uiDesignView, setUIDesignView] = useState(null);
    const [companyStatus, setCompanyStatus] = useState(null);

    useEffect(() => {
        getUIDesignView();
        getComapnyStatus();
    }, []);

    useEffect(() => {
        getUIDesignView();
        getComapnyStatus()
    }, [uiDesignView, companyStatus]);

    const openEditGeneralModal = () => {
        setShowEditGeneralModal(true);
    }

    const openEditCompanyStatusModal = () => {
        setShowEditCompanyStatusModal(true);
    }
    
    const getUIDesignView = async () => {
        let response = await fetch("/api/Settings/checkviewtype?policyId=" + policyId, { method: "GET" });
        let data = await response.json();
        if (data.success === false) {
            alert(data.message);
            return;
        }
        setUIDesignView(data.viewType.viewType);
        setLoading(false);
    }

    const updateUIDesignView = async (viewType) => {
        const requestOptions = {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ policyId: policyId, viewType: viewType }),
        };

        let response = await fetch("/api/Settings/updateviewtype", requestOptions);
        let data = await response.json();
        if (data.success === false) {
            alert(data.message);
            return;
        }
        await getUIDesignView();
        if(viewType === "plan_admin")
        {
            window.location.reload();
        }
    }

    const getComapnyStatus = async () => {
        let response = await fetch("/api/Settings/getcompanystatus?policyId=" + policyId, { method: "GET" });
        let data = await response.json();
        if (data.success === false) {
            alert(data.message);
            return;
        }
        setCompanyStatus(data.status);
        setLoading(false);
    }

    const updateCompanyStatus = async (status) => {
        const requestOptions = {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ policyId: policyId, status: status }),
        };

        let response = await fetch("/api/Settings/updatecompanystatus", requestOptions);
        let data = await response.json();
        if (data.success === false) {
            alert(data.message);
            return;
        }
        await getComapnyStatus();
    }

    let editGeneralModal = null;
    if (showEditGeneralModal) {
        editGeneralModal = (
        <EditGeneralSettingModal
            modalLabel={"Edit General"}
            options={["Company Benefits", "Business Owner"]}
            showEditModal={showEditGeneralModal}
            selectedOption={uiDesignView}
            setSelectedOption={updateUIDesignView}
            closeModal={() => setShowEditGeneralModal(false)}
            dropdownLabel={"UI Design View:"}
        />
        );
    }

    let editCompanyStatusModal = null;
    if (showEditCompanyStatusModal)
    {
        editCompanyStatusModal = (
            <EditGeneralSettingModal
                modalLabel={"Company Status"}
                options={["Active", "Cancelled"]}
                showEditModal={showEditCompanyStatusModal}
                selectedOption={companyStatus}
                setSelectedOption={updateCompanyStatus}
                closeModal={() => setShowEditCompanyStatusModal(false)}
                dropdownLabel={"Comapny Status:"}
            />
        );
    }

    let contents = null;
    if (loading) {
        contents = (<CustomLoading />);
    } else {
        contents = (
        <div className="appearance-setting-container">
            {editGeneralModal}
            {editCompanyStatusModal}
            <Card
                className="general-setting"
                label="General"
                actions={<><a href="#" className="RT-Link" onClick={openEditGeneralModal}>Edit</a></>}
            >
                <Line>
                    <div className="RT-Static-Field">
                        <div className='RT-Static-Field__label'>UI Design View:</div>
                        <div className='RT-Static-Field__content'>{uiDesignView}</div>
                    </div>
                </Line>
            </Card>
            <Card
                className="general-setting"
                actions={<><a href="#" className="RT-Link" onClick={openEditCompanyStatusModal}>Edit</a></>}
            >
                <Line>
                    <div className="RT-Static-Field">
                        <div className='RT-Static-Field__label'>Company Status:</div>
                        <div className='RT-Static-Field__content'>{companyStatus}</div>
                    </div>
                </Line>
            </Card>
        </div>
        );
    }

    return (
        <div className="appearance-settings">
        {contents}
        </div>
    );
}

export default GeneralSettings;